// extracted by mini-css-extract-plugin
export default {"navbarMenus":"navbarMenus_navbarMenus__4pVV+","title":"navbarMenus_title__NvTbc","active":"navbarMenus_active__lrvz6"};